// ─────────────────────────────────────────────────────────────────────────────
// Hardcoded dummy content for the Student Area demo.
//
// Modelled on the real platform catalogue (Order Flow / Big Picture / Trader's
// DNA / Systematic / Risk masterclasses, taught by the WCE mentor desk). Art is
// the platform's own sample export, copied into `public/platform-demo/`.
// ─────────────────────────────────────────────────────────────────────────────

import type { StudentAreaDemo } from "./types";

const BASE = "/platform-demo";
const COVER = `${BASE}/masterclasses`;

export const STUDENT_AREA_DEMO: StudentAreaDemo = {
  hero: [
    {
      id: "order-flow",
      titleImage: `${COVER}/title-1.svg`,
      image: `${BASE}/hero.jpg`,
      subtitle: "Read intent before price moves — trade the tape the way desks do.",
      mentorName: "Serge Bering",
      mentorPhoto: `${BASE}/mentor-andrea.jpg`,
      videoCount: 14,
      totalDuration: "3:42:18",
    },
    {
      id: "systematic",
      titleImage: `${COVER}/title-4.svg`,
      image: `${BASE}/hero.jpg`,
      subtitle: "Turn discretionary instinct into a repeatable, rules-based process.",
      mentorName: "Andrea Cimitan",
      mentorPhoto: `${BASE}/mentor-andrea.jpg`,
      videoCount: 21,
      totalDuration: "5:12:44",
    },
    {
      id: "big-picture",
      titleImage: `${COVER}/title-2.svg`,
      image: `${BASE}/hero.jpg`,
      subtitle: "Frame every setup inside the prevailing macro regime.",
      mentorName: "Lars Vogel",
      mentorPhoto: `${BASE}/mentor-andrea.jpg`,
      videoCount: 12,
      totalDuration: "2:58:07",
    },
  ],

  continueWatching: [
    { id: "w1", title: "Order Flow", lesson: "Absorption & exhaustion", progress: 64, duration: "18:42", cover: `${COVER}/cover-1.jpg` },
    { id: "w2", title: "Big Picture", lesson: "Mapping the macro regime", progress: 28, duration: "24:10", cover: `${COVER}/cover-2.jpg` },
    { id: "w3", title: "Trader's DNA", lesson: "Pre-session routine", progress: 81, duration: "12:05", cover: `${COVER}/cover-3.jpg` },
    { id: "w4", title: "Systematic Trading", lesson: "Defining your edge", progress: 12, duration: "31:27", cover: `${COVER}/cover-4.jpg` },
    { id: "w5", title: "Risk", lesson: "Position sizing models", progress: 47, duration: "21:53", cover: `${COVER}/cover-5.jpg` },
  ],

  courses: [
    { id: "order-flow", title: "The Order Flow Masterclass", mentor: "Serge Bering", titleImage: `${COVER}/title-1.svg`, cover: `${COVER}/cover-1.jpg`, videoCount: 14, totalDuration: "3:42:18", description: "Spot absorption, exhaustion and the footprints of real intent before they show up on the chart." },
    { id: "big-picture", title: "The Big Picture Masterclass", mentor: "Lars Vogel", titleImage: `${COVER}/title-2.svg`, cover: `${COVER}/cover-2.jpg`, videoCount: 12, totalDuration: "2:58:07", description: "Frame every setup inside the prevailing macro regime so your positioning always has context." },
    { id: "traders-dna", title: "The Trader's DNA Masterclass", mentor: "Tom Becker", titleImage: `${COVER}/title-3.svg`, cover: `${COVER}/cover-3.jpg`, videoCount: 18, totalDuration: "4:21:36", description: "Build the routines and mental models that keep you consistent through drawdowns and win streaks." },
    { id: "systematic", title: "The Systematic Trading Masterclass", mentor: "Andrea Cimitan", titleImage: `${COVER}/title-4.svg`, cover: `${COVER}/cover-4.jpg`, videoCount: 21, totalDuration: "5:12:44", description: "Distil chaotic price action into a small set of high-conviction, rules-based patterns." },
    { id: "risk", title: "The Risk Masterclass", mentor: "Andrea Cimitan", titleImage: `${COVER}/title-5.svg`, cover: `${COVER}/cover-5.jpg`, videoCount: 9, totalDuration: "2:14:52", description: "Master the math of staying in the game — position sizing, correlation and survival." },
  ],

  mentors: [
    { id: "andrea", name: "Andrea Cimitan", role: "4× World Trading Champion", photo: `${BASE}/mentor-andrea.jpg`, gradient: "from-[#1f4b5e] to-black" },
    { id: "serge", name: "Serge Bering", role: "Order-Flow Specialist", photo: null, gradient: "from-[#3a2f5e] to-black" },
    { id: "lars", name: "Lars Vogel", role: "Macro Strategist", photo: null, gradient: "from-[#5e402f] to-black" },
    { id: "tom", name: "Tom Becker", role: "Trading Psychologist", photo: null, gradient: "from-[#2f5e3a] to-black" },
    { id: "mia", name: "Mia Hartmann", role: "Quant Researcher", photo: null, gradient: "from-[#5e2f4b] to-black" },
  ],
};
